import { FunctionComponent } from "react";

import { ApiHealthHistoryEntry, ApiHealthStatus } from "../schema/api-health";

const BAR_CLASSES: Record<ApiHealthStatus, string> = {
	OK: "bg-green-500",
	DRIFT: "bg-slate-400",
	INPUT_REJECTED: "bg-blue-400",
	EMPTY: "bg-amber-500",
	BREAKING: "bg-red-500",
	DOWN: "bg-red-700",
};

interface UptimeBarProps {
	entries: ApiHealthHistoryEntry[];
}

/**
 * The classic uptime strip, oldest on the left.
 *
 * History arrives newest-first (that is the order the alerting needs), so it is reversed here
 * rather than in the API — reading left-to-right as time moving forward is the whole point of the
 * shape.
 *
 * Nothing here calls a Date method on `checkedAt`. The type says Date and `transformResponse` makes
 * that true, but `baseQueryWithValidation` applies no schema of its own, so a query wired without a
 * transform delivers the raw ISO string — and `toISOString()` on a string took down the whole page.
 */
export const UptimeBar: FunctionComponent<UptimeBarProps> = ({ entries }) => {
	if (entries.length === 0) {
		return null;
	}

	return (
		<div className="flex items-end gap-[2px] overflow-x-auto">
			{[...entries].reverse().map((entry) => (
				<span
					key={`${String(entry.checkedAt)}-${entry.mode}`}
					className={`h-6 w-[6px] shrink-0 rounded-sm ${BAR_CLASSES[entry.status]}`}
					title={`${entry.status} · ${entry.checkedAt.toLocaleString()}${
						entry.latencyMs ? ` · ${entry.latencyMs}ms` : ""
					}`}
				/>
			))}
		</div>
	);
};
